(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const containers = document.querySelectorAll('[data-asset-credits]');

    containers.forEach((container) => {
      const trigger = container.querySelector('[data-asset-credits-trigger]');
      const popover = container.querySelector('[data-asset-credits-popover]');
      const close = container.querySelector('[data-asset-credits-close]');

      if (!trigger || !popover || !close) return;

      const setOpen = (isOpen) => {
        container.classList.toggle('is-open', isOpen);
        if (isOpen) {
          container.classList.remove('is-dismissed');
        }
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      };

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = container.classList.contains('is-open');
        setOpen(!isOpen);
      });

      close.addEventListener('click', (event) => {
        event.preventDefault();
        container.classList.add('is-dismissed');
        setOpen(false);
      });

      trigger.addEventListener('mouseenter', () => {
        container.classList.remove('is-dismissed');
      });

      trigger.addEventListener('focus', () => {
        container.classList.remove('is-dismissed');
      });

      document.addEventListener('click', (event) => {
        if (!container.contains(event.target)) {
          setOpen(false);
        }
      });

      container.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          setOpen(false);
          trigger.focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
